import axios from "axios";
import Settings from "./config";
import { getApiEndpoint } from "./utilities";

export default {
  getSystemBooking(id, cb) {
    axios.get(getApiEndpoint() + "api/spa/" + id).then((response) => {
      cb(response.data);
    });
  },
  getConfiguration(cb) {
    axios.get("/umbraco/api/spa/getConfiguration").then((response) => {
      cb(response.data);
    });
  },

  getActivities(id, cb) {
    axios.get(getApiEndpoint() + "api/spa/activities").then((response) => {
      cb(response.data);
    });
  },

  getActivitiesList(payload, cb, fcb) {
    axios
      .get(
        getApiEndpoint() +
        "api/spa/activities/" +
        payload.fromDate +
        "/" +
        payload.toDate
      )
      .then((response) => {
        cb(response.data);
      })
      .catch((response) => {
        fcb(response);
      });
  },
  fetchGroupAvailability(payload, cb) {
    axios
      .post(getApiEndpoint() + "api/spa/groups", payload)
      .then((response) => {
        cb(response.data);
      });
  },

  getPackages(id, payload, cb) {
    axios
      .post(getApiEndpoint() + "api/spa/packages", payload)
      .then((response) => {
        cb(response.data);
      });
  },
  getFacilitiesAvailability(id, payload, cb) {
    axios
      .post(getApiEndpoint() + "api/spa/facilities", payload)
      .then((response) => {
        cb(response.data);
      });
  },
  buildItinerary(payload, cb, rej) {
    axios
      .post(getApiEndpoint() + "api/spa/build-itinerary", payload)
      .then((response) => {
        cb(response.data);
      })
      .catch((reject) => {
        rej(response);
      });
  },

  getAvailability(payload, cb) {
    axios
      .post(getApiEndpoint() + "api/spa/search", payload)
      .then((response) => {
        cb(response.data);
      });
  },

  getExtras(payload, cb) {
    axios
      .post(getApiEndpoint() + "api/spa/extras", payload)
      .then((response) => {
        cb(response.data);
      });
  },

  beginBooking(id, payload, cb, rej) {
    axios
      .post(getApiEndpoint() + "api/spa/" + id + "/begin-booking", payload)
      .then((response) => {
        cb(response.data);
      })
      .catch((response) => {
        if (response != undefined) {
          rej(response.data);
        }
      });
  },
  processBooking(id, cb, rej) {
    axios
      .post(getApiEndpoint() + "api/spa/" + id + "/process-booking")
      .then((response) => {
        cb(response.data);
      })
      .catch((response) => {
        if (response != undefined) {
          rej(response.data);
        }
      });
  },
  fetchBookings(cb, rej) {
    axios
      .get(getApiEndpoint() + "api/spa/user-bookings")
      .then((response) => {
        cb(response.data);
      })
      .catch((response) => {
        if (response != undefined) {
          rej(response.data);
        }
      });
  },
  fetchBooking(id, cb, rej) {
    axios
      .get(getApiEndpoint() + "api/spa/retrieve/" + id)
      .then((response) => {
        cb(response.data);
      })
      .catch((response) => {
        if (response != undefined) {
          rej(response.data);
        }
      });
  },
  sendEmail(payload, cb, fcb) {
    axios
      .post(getApiEndpoint() + "api/spa/send-email/", payload)
      .then((response) => {
        cb(response.data);
      })
      .catch((response) => {
        fcb();
      });
  },

  async validateFields(payload, cb, fail) {
    var email =
      payload.leadGuest.emailAddress != null
        ? payload.leadGuest.emailAddress
        : "";
    var telephone =
      payload.leadGuest.telephone != null ? payload.leadGuest.telephone : "";

    if (email) {
      try {
        const emailResponse = await axios.post(
          `${Settings.WWWENDPOINT}/verifyEmail?email=${encodeURIComponent(
            email
          )}`
        );

        const emailResult = emailResponse.data;
        const invalidEmailStatuses = [
          "undeliverable",
          "illegitimate",
          "unreachable",
        ];

        if (invalidEmailStatuses.includes(emailResult)) {
          fail("Email is not valid.");
          return;
        }
      } catch (error) {
        fail("Email validation failed.");
        return;
      }
    }

    if (telephone) {
      try {
        const telephoneResponse = await axios.post(
          `${Settings.WWWENDPOINT
          }/verifyTelephone?telephone=${encodeURIComponent(telephone)}`
        );
        const telephoneResult = telephoneResponse.data;
        const invalidTelephoneStatuses = ["unverified", "dead"];

        if (invalidTelephoneStatuses.includes(telephoneResult)) {
          fail("Telephone is not valid.");
          return;
        }
      } catch (error) {
        fail("Telephone validation failed.");
      }
      cb("valid");
    }
  },
};
